(()=>{
  let opener;
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-ab-size-open]');
    if(open){
      const dialog=document.getElementById(open.dataset.abSizeOpen);
      if(!dialog)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      opener=open;
      if(dialog.open&&!dialog.matches(':modal'))dialog.close();
      if(!dialog.open)dialog.showModal();
      return;
    }
    const close=event.target.closest('[data-ab-size-close]');
    if(close){close.closest('dialog').close();return;}
    if(event.target.matches('dialog.ab-size-guide[open]')){
      const rect=event.target.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();
    }
  },true);
  document.addEventListener('close',event=>{
    if(event.target.matches('dialog.ab-size-guide'))opener?.focus();
  },true);
})();
